var exports = {
  "kL": "xa15a2ab7--3515d1--container",
  "Qs": "xa15a2ab7--3515d1--content",
  "rb": "xa15a2ab7--3515d1--selectable",
  "vu": "xa15a2ab7--3515d1--active",
  "Sl": "xa15a2ab7--3515d1--image",
  "lq": "xa15a2ab7--3515d1--viewed",
  "hu": "xa15a2ab7--3515d1--deactivated",
  "q9": "xa15a2ab7--3515d1--price",
  "Qd": "xa15a2ab7--3515d1--hide-button",
  "h_": "xa15a2ab7--3515d1--description",
};

module.exports = exports;
